import {
  TOGGLE_DROPDOWN,
  SET_SEARCHED_TEXT,
  SET_DISPLAYED_OPTIONS,
  SET_SELECTED_OPTION,
} from './actions';

import { DropdownState, DropdownAction } from './types';

export const initialState: DropdownState = {
  dropdownOpen: false,
  searchedText: '',
  displayedOptions: [],
  selectedOption: 'Select an Option',
};

export const dropdownReducer = (
  state: DropdownState,
  action: DropdownAction,
): DropdownState => {
  switch (action.type) {
    case TOGGLE_DROPDOWN:
      return { ...state, dropdownOpen: !state.dropdownOpen };

    case SET_SEARCHED_TEXT:
      return { ...state, searchedText: action.payload };

    case SET_DISPLAYED_OPTIONS:
      return { ...state, displayedOptions: action.payload };

    case SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.payload };

    default:
      return state;
  }
};
